import Vue from 'vue'

import { getData, reportData, pollTask } from '_api/activity-common-template'
import { utils } from '_lib/utils'
// import cptNav from '_com/base/Nav'
import cptNav from '_com/base/page-nav/index.vue' 
import heyboxLogo from '_com/base/page-nav/components/heybox-logo.vue'
import cptLoading from '_com/base/LoadingActivity'
import cptScreenShot from './components/cpt-screenshot/index.vue'

import './style/font.css'

export default {
  render (h) {
    let children = [
      h('cpt-loading', {
        directives: [
          {
            name: 'show',
            value: this.showLoading
          }
        ],
        props: {
          bg: window.cpt_loading_bg,
          circle_color: window.cpt_loading_color
        }
      }),
      h('div', {
        attrs: {
          id: 'content'
        },
        class: [
          'content'
        ]
      }),
      h('cpt-screen-shot', {
        props: {
          showScreenShot: this.showScreenShot,
          screenShotData: this.screenShotData
        }
      })
    ]
    if (this.showNav) {
      children.push(h('cpt-nav', {
        props: {
          startDistance: this.navStartDistance,
          endDistance: this.navEndDistance,
          bg: this.navBgColor,
          isFixed: this.navIsFixed,
          isUseOver: this.navIsUseOver,
          inputHeight: this.navHeight,
          // logoMarginBottom: this.navLogoMarginBottom,
          scrollDomSelector: this.domListener
        },
        scopedSlots: {
          base: props => h('heyboxLogo', {
            props: {
              'logo-color': this.navLogoColor
            }
          })
        },
      }))
    }
    return h('div', {
      attrs: {
        id: 'app'
      }
    }, children)
  },
  data () {
    return {
      showLoading: true,
      color: '#FFF',
      showScreenShot: false,
      screenShotData: null,
      showNav: false,
      navHeight: 0,
      navStartDistance: 0,
      navEndDistance: 0,
      navIsFixed: true,
      navIsUseOver: false,
      navBgColor: '',
      navLogoColor: '',
      navLogoMarginBottom: 0,
      domListener: ''
    }
  },
  mounted () {
    window.onScreenShared = () => {
      this.showScreenShot = false
      if (window.shot_screen_top) {
        window.scrollTo(0, window.shot_screen_top)
      }
    }
    let querys = utils.getParams()
    let _this = this
    let params = {
      act_id: querys.act_id,
      heybox_id: querys.heybox_id,
      task_os_type: window.task_os_type,
      client_version: window.version,
      is_share: querys.is_share
    }
    if (querys.invite_code) {
      params.invite_code = querys.invite_code
    }
    const getMock = () => {
      return new Promise(resolve => {
        resolve({ data: require("../mock/content.json")})
      })
    }
    // getMock().then(res => {
      // console.log(res);
    getData(params).then(res => {
      // console.log(res);
      if (res.data.status === 'ok') {
        let json = res.data.result;
        querys = Object.assign(querys, {
          task_os_type: window.task_os_type,
          version: window.version
        })
        // 如果是新加的排序的话，排序显示
        // if (json.components_data[0].component_conf.hasOwnProperty('index')) {
        //   json.components_data.sort((a, b) => a.component_conf.index - b.component_conf.index)
        // }
        if (window.innerWidth > 480) {
          this.$el.style.background = json.common_config.side_bg
        }
        // }, ...json.components_data, require('./config/vote.json'), require('./config/puzzle.json'), require('./config/pass-act.json')]
        const content_bg = json.common_config.content_bg
        const isImg = content_bg.indexOf('http') !== -1
        const is_in_heybox = utils.isInHeybox()
        this.navStartDistance = json.common_config.nav_start_distance || 20
        this.navEndDistance = json.common_config.nav_end_distance || json.common_config.nav_show_distance || 52
        console.log(this.navStartDistance, this.navEndDistance);
        this.navBgColor = json.common_config.nav_bg_color || ''
        this.navIsFixed = json.common_config.nav_is_fixed === false ? false : true
        this.navLogoColor = json.common_config.nav_logo_color || ''
        this.navLogoMarginBottom = json.common_config.nav_logo_margin_bottom || 0
        this.navIsUseOver = json.common_config.nav_is_use_over === false ? false : true
        this.domListener = json.common_config.bg_fixed ? '#outer-content' : 'window'
        if (is_in_heybox) {
          json.common_data.nav_height = this.navHeight = utils.executeProtocolSync({protocol_type: "getNavigationBarHeight"})
          this.showNav = json.common_config.show_nav
        } else {
          json.common_data.nav_height = 50
        }
        
        let cpts = Array.from(new Set(json.components_data.map((item) => {
          return item.component_name
        }).concat('cpt-share-header')))

        let asyncComponentsMap = {}
        const groupCpts = ['cpt-hedan', 'cpt-float-post', 'cpt-mall-unlock', 'cpt-pubg-recall', 'cpt-festival-draw-lots', 'cpt-seckill-sale']
        cpts.forEach((cptName) => {
          asyncComponentsMap[cptName] = (resolve) => {
            import(`./components/${groupCpts.includes(cptName) ? `${cptName}/index` : cptName}.vue`).then((md) => {
              resolve(md.default)
            })
          }
        })

        let ContentInstance = Vue.extend({
          data () {
            return {
              json,
              bottom_fixed_height: 0,
              existCpts: json.components_data.map(item => item.component_name),
              is_jump_from_task: '', // 跳转页面时的组件
              jump_from_task_ids: '', // 跳转页面时的id
              jump_from_act_id: '', // 跳转页面时任务的act_id
              task_poll_count: 0,
              needReloadCpts: [
                'cpt-user-info', 'cpt-lottery', 'cpt-hedan',
                'cpt-exchange', 'cpt-pass-act', 'cpt-new-award', 
                'cpt-count-down', 'cpt-receive', 'cpt-divide-award', 
                'cpt-divide-card', 'cpt-open-box', 'cpt-collect-card',
                'cpt-timely-collection', 'cpt-festival-draw-lots', 
                'cpt-seckill-sale'
              ],
              forceUpdateCpts: [
                'cpt-task', 'cpt-mall-unlock', 'cpt-lucky-card','cpt-event-rewards'
              ]
            }
          },
          computed: {
            components_data () {
              return [{
                component_name: 'cpt-share-header',
                component_data: {},
                component_conf: {}
              }, ...this.json.components_data].filter((cpt) => {
                if (is_in_heybox) {
                  if (cpt.component_conf.show_groups) {
                    return cpt.component_conf.show_groups.indexOf('heybox') >= 0
                  }
                  return true
                } else {
                  if (cpt.component_conf.show_groups) {
                    return cpt.component_conf.show_groups.indexOf('share') >= 0
                  }
                  return true
                }
              })
            },
            common_data () {
              return this.json.common_data
            }
          },
          render (h) {
            return h('div', {
              attrs: {
                id: 'outer-content'
              },
              directives: [
                this.json.common_config.bg_fixed === 'between' ? 
                  {
                    name: 'bg',
                    value: `url(${this.json.common_config.content_bg_img_top}) no-repeat top / 100%, url(${this.json.common_config.content_bg_img_bottom}) no-repeat bottom / 100%, url(${this.json.common_config.content_bg_img_center}) repeat-y center / 100%`
                  }
                :
                  {
                    name: 'bg',
                    value: isImg ? `url(${content_bg}) repeat-y top center / 100% auto` : content_bg,
                  }
              ],
              style: this.json.common_config.bg_fixed === 'between' ? 
                {
                  'height': '100vh',
                  'padding-bottom': this.bottom_fixed_height + 'px'
                } 
                  : 
                {
                  'height': this.json.common_config.bg_fixed ? '100vh' : 'auto',
                  'overflow-y': this.json.common_config.bg_fixed ? '' : 'hidden',
                  'padding-bottom': this.bottom_fixed_height + 'px'
                }
            }, [
              h('div', {
                attrs: {
                  id: 'inner-content'
                },
                style: {
                  'position': 'relative'
                }
              }, this.components_data.map((cpt, index) => {
                return h(cpt.component_name, {
                  props: {
                    act_id: cpt.act_id, //act_id
                    cd: cpt.component_data, // component_data
                    cc: cpt.component_conf, // component_config
                    gc: this.json.common_config, // global_config
                    gd: this.common_data, // global_data
                    cpt_name: cpt.component_name,
                    cpt_index: index,
                    querys, // url参数
                  },
                  ref: 'inner-item-' + index
                })
              }))
            ]
            )
          },
          mounted () {
            if (is_in_heybox) {
              window.pageVisibleFromOthersPage = () => {
                reload()
              }
              window.pageVisibleFromBackend = () => {
                reload()
              }
            } else {
              utils.pageChange(() => {
                reload()
              })
            }

            const reload = () => {
              // 点击任务跳转 || 截图后回到页面
              if (this.is_jump_from_task || _this.is_jump_from_screenshot) {
                _this.is_jump_from_screenshot = false
                this.pollTask()
              } else {
                setTimeout(() => {
                  this.reload()
                }, 200)
              }
            }
            
            this.$nextTick(() => {
              if (this.json.common_config.bg_fixed !== 'between') return
              let outerDom = document.querySelector('#outer-content')
              outerDom.addEventListener('scroll', ()=> {
                outerDom.style.backgroundPosition = `center top, center bottom, center calc(50% - ${outerDom.scrollTop}px)`
              })
            })

            setTimeout(() => {
              let flag = false
              this.components_data.forEach((cpt, index) => {
                let SHOULD_FORCE_UPDATE = this.forceUpdateCpts.indexOf(cpt.component_name) >= 0
                if (SHOULD_FORCE_UPDATE) {
                  if (this.$refs[`inner-item-${index}`] && this.$refs[`inner-item-${index}`].hasEnterActivityTaskDone) {
                    flag = true
                    console.log('in SHOULD_FORCE_UPDATE', this.act_id)
                    this.jump_from_task_ids = this.$refs[`inner-item-${index}`].hasEnterActivityTaskDone
                    this.jump_from_act_id = this.act_id
                  }
                }
              })
              if (flag) {
                this.is_jump_from_task = true
                this.pollTask()
              }
            }, 0)

            window.openOrder = this.openOrderDetail.bind(this)
          },
          methods: {
            // 有下面这些组件时才请求
            reload () {
              console.log('正在reload组件')
              const needReload = this.existCpts.filter(item => this.needReloadCpts.includes(item))
              const forceReload = this.existCpts.filter(item => this.forceUpdateCpts.includes(item))
              
              if (needReload.length == 0 && forceReload.length == 0) {
                return
              }
              getData({
                act_id: this.act_id || querys.act_id,
                heybox_id: querys.heybox_id,
                task_os_type: window.task_os_type,
                client_version: window.version
              }).then(res => {
                if (res.data.status === 'ok') {
                  const json = res.data.result
                  // if (json.components_data[0].component_conf.hasOwnProperty('index')) {
                  //   json.components_data.sort((a, b) => a.component_conf.index - b.component_conf.index)
                  // }
                  // json.components_data[1].component_data.hb_num = 23333
                  // json.components_data[1].component_data.state = 2
                  const cptIndexs = [], forceUpdateIndexs = []
                  const component_names = json.components_data.map(item => item.component_name)

                  needReload.forEach(item => {
                    const index = component_names.indexOf(item)
                    if (index !== -1) {
                      cptIndexs.push(index)
                    }
                  })
                  forceReload.forEach(item => {
                    const index = component_names.indexOf(item)
                    if (index !== -1) {
                      forceUpdateIndexs.push(index)
                    }
                  })

                  this.$set(this.json, 'common_data', json.common_data)

                  cptIndexs.forEach(index => {
                    if (JSON.stringify(json.components_data[index]) !== JSON.stringify(this.json.components_data[index])) {
                      this.$set(this.json.components_data, index, json.components_data[index])
                    }
                  })
                  forceUpdateIndexs.forEach(index => {
                    this.$set(this.json.components_data, index, json.components_data[index])
                  })
                }
              })
              this.updateFixedBottom()
            },
            // 点击任务返回页面后，轮询点击的任务是否完成(任务模块、层级解锁模块)
            pollTask () {
              if (!is_in_heybox) {
                utils.executeProtocolOutApp({
                  "protocol_type": "openWindow",
                  "webview": {
                    "url": window.location.origin + window.location.pathname + '?act_id=' + querys.act_id
                  },
                  navigation_bar: {
                    title: "小黑盒"
                  }
                })
                return
              }
              if (this.req_lock) {
                setTimeout(() => {
                  this.pollTask(task)
                }, 200)
                return
              }
              this.req_lock = true
              this.task_poll_count++
              let task_params = {
                act_id: this.jump_from_act_id
              }
              if (this.jump_from_task_ids) {
                task_params.task_ids = this.jump_from_task_ids
              }
              pollTask(task_params).then((res) => {
                this.req_lock = false
                if (res.data.status == 'ok') {
                  var data = res.data.result && res.data.result.data
                  // 任务完成了
                  if (data && data[this.jump_from_task_ids] && data[this.jump_from_task_ids].state == 1) {
                    this.jump_from_task_ids = ''
                    this.jump_from_act_id = ''
                    this.is_jump_from_task = false
                    this.task_poll_count = 0
                    this.reload()
                  } else { // 没完成继续请求
                    if (this.task_poll_count >= 5) {
                      this.task_poll_count = 0
                      this.jump_from_task_ids = ''
                      this.jump_from_act_id = ''
                      this.is_jump_from_task = false
                    } else {
                      setTimeout(() => {
                        this.pollTask()
                      }, [200, 200, 500, 800, 1200, 1500][this.task_poll_count])
                    }
                  }
                } else {
                  this.task_poll_count = 0
                }
              }).catch((e) => {
                this.task_poll_count = 0
              })
            },
            openOrderDetail (order_id) {
              utils.executeProtocol({
                protocol_type: "openOrderDetail",
                order_id: order_id
              })
            },
            updateFixedBottom () { // 计算更新底部给fixed元素占位的padding
              let heights = []
              for (let key in this.$refs) {
                let dom = this.$refs[key]
                if (dom.$refs && dom.$refs['img-fixed']) {
                  heights.push(dom.$refs['img-fixed'].offsetHeight)
                }
              }
              this.$nextTick(() => {
                if (heights.length > 0) {
                  this.bottom_fixed_height = Math.max.apply(this,heights)
                } else {
                  this.bottom_fixed_height = 0
                }
              })
            },
            setScreenShot (data) {
              _this.setScreenShot(data)
            },
            onScreenShot () {
              _this.onScreenShot()
            }
          },
          components: asyncComponentsMap
        })
        new ContentInstance().$mount('#content')
        setTimeout(() => {
          this.showLoading = false
        }, 100)
        // imgsHandler(json).then(() => {
        //   this.showLoading = false
        // })
        window._time_start = Date.parse(new Date())
        utils.pageChange(() => {
          if (is_in_heybox) {
            window._time_start = Date.parse(new Date())
          }
        }, () => {
          if (is_in_heybox) {
            const staySecond = (Date.parse(new Date()) - window._time_start) / 1000
            reportData({
              type: '401',
              act_id: querys.act_id,
              time_sec: staySecond,
              heybox_id: querys.heybox_id
            })
          }
        })
      }
    })
  },
  methods: {
    setScreenShot (data) {
      this.screenShotData = data
    },
    onScreenShot () {
      this.showScreenShot = true
    }
  },
  components: {
    cptNav,
    cptLoading,
    heyboxLogo,
    cptScreenShot
  }
}
function imgsHandler (json) {
  return new Promise(resolve => {
    const content_bg = json.common_config.content_bg
    const isImg = content_bg.indexOf('http') !== -1
    if (!isImg) {
      setTimeout(() => {
        resolve()
      }, 200)
    } else {
      utils.prefetchImage([content_bg]).then(() => {
        resolve()
      })
    }
    // 处理内容背景图
    setTimeout(() => {
      let section_bgs = Object.values(json.common_config.section_bg)
      utils.prefetchImage(section_bgs.filter(item => item))
    }, 500)
    // 处理弹窗背景图
    setTimeout(() => {
      let modal_bgs = Object.values(json.common_config.modal_bg)
      utils.prefetchImage(modal_bgs.filter(item => item))
    }, 1500)
  })
}